import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

interface MetadataManagerProps {
  title?: string;
  description?: string;
  image?: string;
  favicon?: string;
}

export default function MetadataManager({ 
  title = 'NodeRocks - Digital Art on Bitcoin',
  description = 'Digital artifacts on Bitcoin | Yin Yang inscriptions blending Finance & Meme culture | First and last 10k Yin Yang Collection | 100% community based.',
  image = 'https://i.ibb.co/bsqv2bm/04d7ecfa0f651091b1366484da95acfd95430147dd415965d2cee215ee8ec202.jpg',
  favicon = 'https://i.ibb.co/ssSFQ3q/icon.png'
}: MetadataManagerProps) {
  const { i18n } = useTranslation();

  useEffect(() => {
    // Update title and meta description
    document.title = title;
    document.querySelector('meta[name="description"]')?.setAttribute('content', description);

    // Update favicon
    const links = document.querySelectorAll("link[rel*='icon']");
    links.forEach(link => link.remove()); // Remove existing favicons

    const newFavicon = document.createElement('link');
    newFavicon.type = 'image/x-icon';
    newFavicon.rel = 'shortcut icon';
    newFavicon.href = favicon;
    document.head.appendChild(newFavicon);

    // Update OpenGraph meta tags
    const ogTags = {
      'og:title': title,
      'og:description': description,
      'og:image': image,
      'og:type': 'website',
      'og:site_name': 'NodeRocks',
    };

    // Update Twitter Card meta tags
    const twitterTags = {
      'twitter:card': 'summary_large_image',
      'twitter:title': title,
      'twitter:description': description,
      'twitter:image': image,
      'twitter:site': '@NodeRocks_BTC',
    };

    // Helper function to update meta tags
    const updateMetaTag = (name: string, content: string) => {
      let meta = document.querySelector(`meta[property="${name}"]`) || 
                document.querySelector(`meta[name="${name}"]`);
      
      if (!meta) {
        meta = document.createElement('meta');
        if (name.startsWith('og:')) {
          meta.setAttribute('property', name);
        } else {
          meta.setAttribute('name', name);
        }
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    };

    // Update all meta tags
    Object.entries(ogTags).forEach(([name, content]) => updateMetaTag(name, content));
    Object.entries(twitterTags).forEach(([name, content]) => updateMetaTag(name, content));

  }, [title, description, image, favicon]);

  // Update language meta tag
  useEffect(() => {
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  return null;
}